import { render } from "./cage-breadcrumb.vue?vue&type=template&id=4d76885a"
import script from "./cage-breadcrumb.vue?vue&type=script&lang=js"
export * from "./cage-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__